import React, { useState, useEffect, useContext } from "react";
// import DatePicker from "react-datepicker";
import { DataContext } from "../../store/GlobalState";
import { ACTIONS } from "../../store/Actions";

import Fill1 from "../images/Fill 1.svg";
import cross from "../images/cross.svg";
import { ButtonsContainer } from "../PhenEditForm/PhenomenonEditForm";
import { requestTranslation } from "@futures-platform/i18n";
import { Modal, paddingModalStyles } from "@futures-platform/ui";

const HistoryEditor = ({
  closeModal,
  openModal,
  history,
  index,
  historyDataState,
  sethistoryDataState,
  isShowDeleteHistoryModal,
  setisShowDeleteHistoryModal,
  gid
}) => {
  const {
    state: { currentIndexEditingHistory },
    dispatch,
  } = useContext(DataContext);

  const onVisiblityHandler = () => {
    const temp = [...historyDataState]
    const temp2 = { ...history }
    temp2['isShown'] = !temp2['isShown']
    const indexTemp = temp.findIndex((x) => x?.id === history?.id)
    temp[indexTemp] = { ...temp2 }
    sethistoryDataState(() => [...temp])
  };

  const onDeleteHistoryLogHandler = () => {
    const historyId = sessionStorage.getItem("historyId");

    const temp = [...historyDataState];
    const temp2 = !!temp?.length
      ? temp?.filter((h) => String(h?.id) !== String(historyId))
      : [];
    sethistoryDataState(() => [...temp2]);
    setisShowDeleteHistoryModal(false);
  };
  return (
    <>
      <Modal
        isOpen={isShowDeleteHistoryModal}
        onRequestClose={() => setisShowDeleteHistoryModal(false)}
        style={paddingModalStyles}
        ariaHideApp={false}
      >
        <div className="modal-form-sections">
          <div
            className="modal-form-section modal-form-header"
            style={{ paddingBottom: "1px" }}
          >
            <h3>{requestTranslation("Removeevent")} </h3>
          </div>
          <div
            id="history-content-card-editor"
            className="modal-form-section"
            style={{ paddingTop: 0, cursor: "pointer" }}
          >
            {requestTranslation("RemoveeventText")}
          </div>
        </div>

        <ButtonsContainer className={"modal-form-section modal-form-actions"}>
          <button
            className="btn btn-lg btn-plain-gray"
            onClick={() => {
              setisShowDeleteHistoryModal(false);
            }}
          >
            {requestTranslation("cancel")}
          </button>
          <button
            className="btn btn-lg btn-primary"
            onClick={() => {
              onDeleteHistoryLogHandler();
              // setPhenomenonToTag(false)
              // dispatch({
              //   type: ACTIONS.CURRENTINDEXEDITINGHISTORY,
              //   payload: -99
              // })
              // setisEditHistoryModalOpened(false);
            }}
            // type="submit"
          >
            {requestTranslation("yes")}
          </button>
        </ButtonsContainer>
      </Modal>
      <div className="d-flex justify-content-between w-100">
        <div
          style={{
            marginBottom: "16px",
          }}
        >
          <p
            id="dmmay"
            style={{
              margin: 0,
              color: "#637282",
            }}
          >{`${!!history?.isCreator ? requestTranslation("Created") : requestTranslation("Edited")} ${requestTranslation("on")} ${
            history?.date
          } ${requestTranslation("by")} ${Number(gid) !== 0 ? history?.editorName : 'Futures Platform'}`}</p>
          <p
            style={{
              margin: 0,
              fontWeight: 500,
            }}
          >
            {history?.description}
          </p>
        </div>

        <div className="d-flex">
          {!history?.isShown && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
              onClick={onVisiblityHandler}
              // style={{ width: "5%", justifyContent: "flex-end", display: "flex" }}
            >
              <span
                className=" af-custom-eye-blocked"
                style={{
                  fontSize: "1.5em",
                  color: "#808080",
                  cursor: "pointer",
                }}
              />
            </a>
          )}

          {!!history?.isShown && (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a onClick={onVisiblityHandler}>
              <span
                className=" af-custom-eye"
                style={{
                  fontSize: "1.5em",
                  color: "#808080",
                  cursor: "pointer",
                }}
              />
            </a>
          )}

          <div
            onClick={() => {
              const indexTemp = historyDataState.findIndex((x) => x?.id === history?.id)
              dispatch({
                type: ACTIONS.CURRENTINDEXEDITINGHISTORY,
                payload: indexTemp,
              });
              openModal();
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <img
              style={{
                height: "20px",
                width: "20px",
                position: "relative",
                display: "flex",
                cursor: "pointer",
              }}
              className="ml-6"
              src={Fill1}
              alt=""
            />
          </div>

          <img
            onClick={() => {
              sessionStorage?.setItem("historyId", history?.id);

              setisShowDeleteHistoryModal(true);
            }}
            style={{
              width: "25px",
              height: "25px",
              position: "relative",
              display: "flex",
              cursor: "pointer",
            }}
            className="ml-4"
            src={cross}
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default HistoryEditor;
